<div class="menu-wrapper">
  <div
    #ttip="qmTooltip"
    [qmTooltip]="menu"
    (click)="openMenu($event, ttip)"
    class="btn-open-menu"
  >
    <fa-icon [icon]="['fas', 'ellipsis-v']"></fa-icon>
  </div>
</div>

<ng-template #menu let-alarm="alarm">
  <div class="action-menu">
    <div *ngIf="!disabledByUser && hasUserRightsToDisableAlarm"
      (click)="setAlarmActivity(alarm, false)"
      [ngClass]="{
        'action-menu-item btn-disable': true
      }"
      placement="right"
    >
      <fa-icon [icon]="['far', 'calendar-times']"></fa-icon>
      <span>{{ 'Disable' | translate}}</span>
    </div>
    <div
      *ngIf="disabledByUser && hasUserRightsToDisableAlarm"
      (click)="setAlarmActivity(alarm, true)"
      [ngClass]="{
        'action-menu-item btn-enable': true
      }"
      placement="right"
    >
      <fa-icon [icon]="['far', 'calendar-plus']"></fa-icon>
      <span>{{ 'Enable' | translate }}</span>
    </div>
    <div
      *ngIf="locateLoading"
      class="action-menu-item btn-unclickable"
    >
      <span>{{ 'Finding location...' | translage }}</span>
    </div>
    <div
      *ngIf="!locateLoading && locateRows?.length < 1"
      class="action-menu-item btn-unclickable"
    >
      <span>{{ 'Unable to locate' | translate }}</span>
    </div>
    <div
      *ngFor="let locateRow of locateRows"
      (click)="focusMarker(locateRow)"
      class="action-menu-item"
    >
      <fa-icon [icon]="['far', 'crosshairs']"></fa-icon>
      <span>{{ 'Locate' | translate }} {{ locateRow.label }}</span>
    </div>
  </div>
</ng-template>
